<template>
    <div class="v2">
        <!-- ==================== 左：实景工厂 ==================== -->
        <div class="visual">
            <div class="photo"></div>
            <div class="overlay">
                <div class="brand-chip">
                    <span class="brand-logo"><img :src="logoMark" alt="中天建设"></span>
                    <div class="txt">
                        <div class="zh">陕西中天建筑工业有限公司</div>
                        <div class="en">SHAANXI ZHONGTIAN CONSTRUCTION INDUSTRIAL CO., LTD.</div>
                    </div>
                </div>

                <div class="hero">
                    <div class="tags">
                        <span>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M3 17l6-6 4 4 8-8"></path>
                                <path d="M14 7h7v7"></path>
                            </svg>销售管理
                        </span>
                        <span>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M2 20h20"></path>
                                <path d="M4 20V10l5 3v-3l5 3v-3l6 3v7"></path>
                            </svg>生产管理
                        </span>
                        <span>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <rect x="1" y="4" width="14" height="12" rx="1"></rect>
                                <path d="M15 9h4l3 3v4h-7z"></path>
                                <circle cx="6" cy="18.5" r="2"></circle>
                                <circle cx="17.5" cy="18.5" r="2"></circle>
                            </svg>车辆调度
                        </span>
                        <span>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <circle cx="9" cy="20" r="1.6"></circle>
                                <circle cx="18" cy="20" r="1.6"></circle>
                                <path d="M2 3h3l2.4 11.2a1.8 1.8 0 0 0 1.8 1.4h8.6a1.8 1.8 0 0 0 1.8-1.4L21.5 7H6"></path>
                            </svg>采购管理
                        </span>
                        <span>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                                <path d="M9 11.5l2 2 4-4"></path>
                            </svg>质量追溯
                        </span>
                        <span>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M3 3v18h18"></path>
                                <path d="M8 16v-5"></path>
                                <path d="M13 16V8"></path>
                                <path d="M18 16v-8"></path>
                            </svg>数据看板
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <!-- ==================== 右：上半系统名称 + 下半登录 ==================== -->
        <div class="panel">
            <div class="inner">
                <div class="title-block">
                    <h1 class="art-title">
                        <span class="line line-1">中天建筑</span>
                        <span class="line">数字化混凝土ERP系统</span>
                    </h1>
                    <div class="title-rule"></div>
                    <p class="panel-slogan">让营销、生产、采购，对账，一目了然</p>
                </div>

                <div class="login-block">
                    <div class="welcome">欢迎登录商砼ERP</div>
                    <p class="welcome-sub">使用手机号与密码登录系统</p>

                    <form @submit.prevent="submit">
                        <div class="field">
                            <svg class="f-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round">
                                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"></path>
                            </svg>
                            <input class="ipt" type="text" v-model.trim="accountNumber" placeholder="请输入手机号" maxlength="11">
                        </div>
                        <div class="field">
                            <svg class="f-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                <rect x="3" y="11" width="18" height="11" rx="2"></rect>
                                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                            </svg>
                            <input class="ipt" type="password" v-model="password" placeholder="请输入密码">
                        </div>
                        <div class="captcha-row">
                            <div class="field">
                                <svg class="f-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                                </svg>
                                <input class="ipt" type="text" v-model="verification" placeholder="请输入验证码" maxlength="4">
                            </div>
                            <div class="cap-code" title="点击刷新验证码" @click="getValiCode">
                                <img :src="verificationImg" alt="验证码">
                            </div>
                        </div>
                        <div class="aux">
                            <label class="remember">
                                <input type="checkbox" v-model="checked">
                                <span class="box">
                                    <svg viewBox="0 0 12 12" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                                        <path d="M2 6.2 4.8 9 10 3.4"></path>
                                    </svg></span>记住密码
                            </label>
                            <a class="forgot" href="javascript:void(0)" @click="resetPassword">忘记密码？</a>
                        </div>
                        <button class="btn-primary" type="submit" :disabled="submitLoading">{{ submitLoading ? '登录中…' : '立即登录' }}</button>
                    </form>

                    <p class="agree">登录即同意 <a href="javascript:void(0)">《用户协议》</a> 及 <a href="javascript:void(0)">《隐私政策》</a></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { reAddRouters } from '@/utils';
import currencyFun from '@/assets/js/currencyFun';
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import cookie from '@/common/NIM/utils/cookie';

export default {
    name: 'zhongtian-login',
    data() {
        return {
            logoMark: require('../images/logo-mark.png'),
            guid: '',
            submitLoading: false,
            accountNumber: '',
            password: '',
            verification: '',
            verificationImg: '',
            checked: false,
        };
    },
    mounted() {
        this.guid = this.newGuid();
        this.getValiCode();
        this.getCookies();
    },
    methods: {
        newGuid() {
            return (
                `${this.s4()}${this.s4()}-${this.s4()}-${this.s4()}-${this.s4()}-${this.s4()}${this.s4()}${this.s4()}`
            );
        },

        s4() {
            return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
        },

        // 获取Cookies保存账号
        getCookies() {
            this.accountNumber = Cookies.get('userName') ? Cookies.get('userName') : '';
            const enPassword = Cookies.get('userPwd') ? Cookies.get('userPwd') : '';
            if (enPassword) {
                this.password = CryptoJS.AES.decrypt(enPassword, 'user').toString(CryptoJS.enc.Utf8);
                this.checked = true;
            } else {
                this.password = '';
            }
        },

        // 记住密码-保存账号到Cookies
        setCookiesUser() {
            if (this.checked) {
                Cookies.set('userName', this.accountNumber, {
                    expires: 3,
                });
                Cookies.set('userPwd', CryptoJS.AES.encrypt(this.password, 'user'), {
                    expires: 3,
                });
            } else {
                Cookies.remove('userName');
                Cookies.remove('userPwd');
            }
        },

        // 验证码
        getValiCode() {
            this.verificationImg = `/interfaceApi/auth/ValidateCode?guid=${this.guid}&width=115&height=54&s=${Math.random()}&fontSize=30`;
        },

        // 登录
        submit() {
            const qs = require('qs');
            if (this.accountNumber === '') {
                this.$message.error('请输入用户账号');
            } else if (this.password === '') {
                this.$message.error('请输入密码');
            } else if (this.verification === '') {
                this.$message.error('请输入验证码');
            } else {
                this.submitLoading = true;
                this.$axios
                    .post('/interfaceApi/login/business', qs.stringify({
                        ImgGuid: this.guid,
                        password: this.password,
                        ImgCode: this.verification,
                        username: this.accountNumber,
                    }), {
                        headers: {
                            ContentType: 'application/x-www-form-urlencoded',
                        },
                    }).then(async res => {
                        this.setCookiesUser();
                        this.loginSucceeded(res);
                    }).catch(res => {
                        if (res.error === 'GO_2002') {
                            this.getValiCode();
                        }
                        this.$message.error(res.error_description);
                    }).finally(() => {
                        this.submitLoading = false;
                    });
            }
        },

        // 登录成功保存用户信息
        async loginSucceeded(res) {
            sessionStorage.setItem('token', `${res.token_type} ${res.access_token}`);
            sessionStorage.setItem('refreshToken', `${res.token_type} ${res.refresh_token}`);
            sessionStorage.setItem('clientID', this.guid);
            // 保存用户信息
            await currencyFun.getUserInfo();
            const name = this.$takeTokenParameters('Name');
            this.getNIMAccount(name, res);
        },

        // 获取云信账号
        getNIMAccount(name, user) {
            this.$axios
                .get('/interfaceApi/message/MessageNetease/GetRelInfo?userName=' + name)
                .then(() => {
                    this.loginWebIM(user);
                    cookie.setCookie('isNIM', 'true');
                    this.loginJump();
                }).catch(error => {
                    cookie.setCookie('isNIM', 'false');
                    this.$message.error(error.ErrorCode.Message);
                    this.loginJump();
                });
        },

        // 登录跳转
        loginJump() {
            localStorage.setItem('menuCode', 'shebc');
            // 重新添加路由信息
            reAddRouters();
            this.$router.push({ path: '/' });
        },

        // 重置密码
        resetPassword() {
            this.$emit('resetPasswordLoadPage');
        },

        // 登录账号
        async loginWebIM(user) {
            this.$imoption.user = user.AccId;
            this.$imoption.pwd = user.Token;
            localStorage.setItem('userDataDetail', JSON.stringify(user));

            this.$imconn.open(this.$imoption);
            const _this = this;
            // 监听回调
            this.$imconn.listen({
                onOpened: function (message) {
                    console.log(message, '用户已上线');
                },
                onClosed: function (message) {
                    console.log(message, '用户下线');
                    _this.$emit('isclose', true);
                },
                // 收到文本消息
                onTextMessage: function (message) {
                    console.log(message, 'messagemessage');
                    if (message.from === _this.accept) {
                        _this.chatContent.push({
                            replyImg: '',
                            replyContent: message.data,
                        });
                    }
                },
            });
        },
    },
};
</script>

<style scoped>
.v2{
    --zt-red:#D8261C;
    --zt-red-deep:#A81414;
    --blue:#2E7CE6;
    --blue-deep:#1E63D8;
    --ink:#1F2329;
    --ink-2:#5A6474;
    --ink-3:#9AA3B2;
    --line:#E5E9F0;
    --card:#FFFFFF;
    --radius-ipt:8px;
    --font:"PingFang SC","HarmonyOS Sans SC","Microsoft YaHei","Source Han Sans SC",sans-serif;
    --ease:cubic-bezier(.22,.61,.36,1);

    min-height:100vh;display:grid;grid-template-columns:58% 42%;
    font-family:var(--font);color:var(--ink);background:#0A1628;
    -webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;
}
button{font-family:inherit;cursor:pointer;border:none;background:none}
input{font-family:inherit;outline:none}
a{text-decoration:none;color:inherit}
.ipt::placeholder{color:var(--ink-3)}

.visual{position:relative;overflow:hidden}
.visual .photo{
    position:absolute;inset:0;
    background:url("../images/factory-aerial.jpg") center/cover no-repeat;
    transform:scale(1.02);animation:slowZoom 26s ease-in-out infinite alternate;
}
@keyframes slowZoom{from{transform:scale(1.02)}to{transform:scale(1.1)}}
.visual::before{
    content:"";position:absolute;inset:0;z-index:1;
    background:
        linear-gradient(180deg,rgba(9,20,38,.60) 0%,rgba(9,20,38,.20) 15%,transparent 32%),
        linear-gradient(200deg,rgba(20,40,80,.14) 30%,rgba(122,20,14,.40) 88%),
        linear-gradient(0deg,rgba(18,30,50,.52),transparent 46%);
}
.overlay{
    position:absolute;z-index:2;inset:0;
    display:flex;flex-direction:column;justify-content:space-between;
    padding:46px 56px 50px;color:#fff;
    animation:rise .8s .1s var(--ease) both;
}

.brand-chip{
    display:flex;align-items:center;gap:16px;
    align-self:flex-start;
}
.brand-logo{
    width:58px;height:58px;border-radius:16px;flex:none;display:grid;place-items:center;
    background:rgba(255,255,255,.92);
    box-shadow:0 8px 22px rgba(4,12,28,.42);
}
.brand-logo img{width:48px;height:48px;object-fit:contain;display:block}
.brand-chip .txt{width:288px}
.brand-chip .zh{
    font-size:19px;font-weight:800;color:#fff;line-height:1.25;
    text-align:justify;text-align-last:justify;
    text-shadow:0 2px 12px rgba(4,12,28,.78),0 1px 3px rgba(4,12,28,.6);
}
.brand-chip .en{
    font-size:9px;color:rgba(255,255,255,.8);letter-spacing:.02em;margin-top:4px;white-space:nowrap;
    text-align:justify;text-align-last:justify;
    text-shadow:0 1px 8px rgba(4,12,28,.72);
}

.hero{padding-bottom:2px}
.art-title{
    display:flex;flex-direction:column;align-items:flex-start;
    font-size:clamp(21px,1.88vw,36px);font-weight:900;line-height:1.24;
    letter-spacing:.012em;
    color:#1E63D8;
    transform:skewX(-5deg);
    filter:drop-shadow(0 8px 18px rgba(18,41,79,.14));
}
.art-title .line{display:block}
.art-title .line-1{letter-spacing:.26em}

.panel-slogan{margin-top:18px;font-size:13px;color:#7E8899;letter-spacing:.18em}
.title-rule{
    width:62px;height:3px;border-radius:3px;margin-top:18px;
    background:linear-gradient(90deg,var(--zt-red),rgba(46,124,230,.55));
}

.tags{display:flex;flex-wrap:wrap;gap:10px; user-select: none;}
.tags span{
    display:inline-flex;align-items:center;gap:7px;
    padding:8px 14px;border-radius:8px;font-size:13px;letter-spacing:.05em;
    background:rgba(255,255,255,.14);border:1px solid rgba(255,255,255,.28);backdrop-filter:blur(8px);
}
.tags svg{width:15px;height:15px;flex:none;opacity:.95}

.panel{
    background:var(--card);display:flex;flex-direction:column;
    padding:52px clamp(32px,4.5vw,72px) 0;position:relative;overflow:hidden;
}
.panel::before{content:"";position:absolute;left:0;top:0;bottom:0;width:5px;z-index:2;
    background:linear-gradient(180deg,var(--zt-red),#F0564A 60%,var(--blue))}
.panel::after{
    content:"";position:absolute;inset:0;z-index:0;pointer-events:none;
    background:url("../images/factory-aerial.jpg") 44% 60%/225% auto no-repeat;
    opacity:.155;
    filter:grayscale(.16) saturate(.74) brightness(1.02) contrast(.98);
    mask-image:radial-gradient(106% 80% at 55% 52%,#000 8%,rgba(0,0,0,.6) 48%,transparent 78%);
    -webkit-mask-image:radial-gradient(106% 80% at 55% 52%,#000 8%,rgba(0,0,0,.6) 48%,transparent 78%);
}
.panel .inner{
    position:relative;z-index:1;
    width:100%;max-width:456px;margin:0 auto;flex:1;min-height:0;
    display:flex;flex-direction:column;
    animation:rise .7s .15s var(--ease) both;
}
.title-block{padding-top:6.5vh;position:relative;z-index:1}
.login-block{margin-top:auto;padding-bottom:11vh;max-width:380px}
.panel .welcome{font-size:24px;font-weight:700;letter-spacing:.08em}
.panel .welcome-sub{font-size:13px;color:var(--ink-3);margin:7px 0 26px;letter-spacing:.05em}

.field{position:relative;margin-bottom:16px}
.field .f-ico{
    position:absolute;left:13px;top:50%;transform:translateY(-50%);
    width:18px;height:18px;color:var(--ink-3);pointer-events:none;transition:color .25s;
}
.field:focus-within .f-ico{color:var(--blue-deep)}
.ipt{
    width:100%;height:46px;padding:0 14px 0 40px;font-size:15px;color:var(--ink);
    border:1px solid var(--line);border-radius:var(--radius-ipt);background:#FAFBFD;
    transition:border-color .25s,box-shadow .25s,background .25s;
}
.ipt:focus{border-color:var(--blue);background:#fff;box-shadow:0 0 0 3px rgba(46,124,230,.12)}
.captcha-row{display:flex;gap:10px}
.captcha-row .field{flex:1;margin-bottom:16px}
.cap-code{
    width:118px;height:46px;border-radius:var(--radius-ipt);border:1px solid var(--line);
    background:#fff;overflow:hidden;flex-shrink:0;cursor:pointer;transition:border-color .25s;
}
.cap-code:hover{border-color:var(--blue)}
.cap-code img{width:100%;height:100%;display:block}
.aux{display:flex;justify-content:space-between;align-items:center;margin:2px 0 20px;font-size:13px;color:var(--ink-2)}
.remember{display:flex;align-items:center;gap:7px;cursor:pointer;user-select:none}
.remember input{display:none}
.remember .box{
    width:16px;height:16px;border-radius:4px;border:1.5px solid #C6CEDA;background:#fff;
    display:grid;place-items:center;transition:all .2s var(--ease);
}
.remember .box svg{width:10px;height:10px;opacity:0;transform:scale(.5);transition:all .2s var(--ease)}
.remember input:checked+.box{background:var(--zt-red);border-color:var(--zt-red)}
.remember input:checked+.box svg{opacity:1;transform:scale(1)}
.forgot{color:var(--ink-2);transition:color .2s}
.forgot:hover{color:var(--zt-red)}
.btn-primary{
    width:100%;height:46px;border-radius:var(--radius-ipt);
    background:linear-gradient(135deg,#E8402F,var(--zt-red) 55%,var(--zt-red-deep));
    color:#fff;font-size:16px;font-weight:600;letter-spacing:.35em;text-indent:.35em;
    box-shadow:0 8px 20px rgba(216,38,28,.32),inset 0 1px 0 rgba(255,255,255,.25);
    transition:all .25s var(--ease);
}
.btn-primary:hover{filter:brightness(1.06);transform:translateY(-1px);box-shadow:0 12px 26px rgba(216,38,28,.4),inset 0 1px 0 rgba(255,255,255,.25)}
.btn-primary:active{transform:translateY(0);filter:brightness(.97)}
.btn-primary:disabled{opacity:.75;cursor:not-allowed}
.agree{margin-top:16px;font-size:12px;color:var(--ink-3);text-align:center}
.agree a{color:var(--blue-deep);transition:color .2s}
.agree a:hover{color:var(--zt-red)}

@keyframes rise{from{opacity:0;transform:translateY(22px)}to{opacity:1;transform:none}}
@media (prefers-reduced-motion:reduce){
    *{animation-duration:.01ms !important;transition-duration:.01ms !important}
}

@media (max-width:1024px){
    .v2{grid-template-columns:1fr;grid-template-rows:44vh auto}
    .overlay{padding:26px 28px}
    .brand-chip{padding:0;gap:12px}
    .brand-logo{width:46px;height:46px;border-radius:13px}
    .brand-logo img{width:38px;height:38px}
    .brand-chip .txt{width:min(258px,58vw)}
    .brand-chip .zh{font-size:15px}
    .brand-chip .en{font-size:8px;white-space:normal;letter-spacing:.04em;line-height:1.5}
    .art-title{font-size:21px}
    .panel-slogan{margin-top:12px;font-size:12px}
    .title-rule{margin-top:12px}
    .title-block{padding-top:2vh}
    .login-block{padding-bottom:5vh}
    .tags{gap:8px}
    .tags span{padding:6px 11px;font-size:12px}
    .panel{padding:34px 26px 0}
}
</style>
